import { SECONDS_IN_MS } from '@/helpers'

const touchMap = new WeakMap()

const formHelperMixin = {
  beforeDestroy () {
    // perform clean up to ensure no timers or handlers are left hanging
    clearInterval(this.timer)
  },

  data () {
    return {
      warning: ''
    }
  },

  methods: {
    delayTouch (validator, disableValidation) {
      if (disableValidation) return validator.$reset()
      if (this.disableDelayedTouch) return
      validator.$reset()

      if (touchMap.has(validator)) {
        clearTimeout(touchMap.get(validator))
      }
      touchMap.set(validator, setTimeout(validator.$touch, SECONDS_IN_MS(1)))
    },

    hasErrorClass (field) {
      return this.errorGenerator(field) ? 'is-danger shake' : ''
    },

    flashWarningUnderField (text, consoleMessage) {
      this.warning = text
      this.timer = setTimeout(() => { this.warning = null }, SECONDS_IN_MS(4))
      if (consoleMessage) {
        console.warn(consoleMessage)
      }
    }
  },
  computed: {
    errorGenerator (field) {
      return (field) => {
        if (field.$error) {
          if (field.$params.email && !field.email) {
            return this.$t('validation.invalid_email')
          }
          if (field.$params.url && !field.url) {
            return this.$t('validation.invalid_url')
          }
          if (field.$params.minLength && !field.minLength) {
            return this.$t('validation.min_length', { num: field.$params.minLength.min })
          }
          if (field.$params.maxLength && !field.maxLength) {
            return this.$t('validation.max_length', { num: field.$params.maxLength.max })
          }
          if (field.$params.validCountry && !field.validCountry) {
            return this.$t('validation.invalid_country')
          }
          if (field.$params.validPhone && !field.validPhone) {
            return this.$t('validation.invalid_phone_number')
          }
          if (field.$params.validState && !field.validState) {
            return this.$t('validation.required')
          }
          if (field.$params.validProvince && !field.validProvince) {
            return this.$t('validation.required')
          }
          if (field.$params.minLenghtOptional && !field.minLenghtOptional) {
            return this.$t('validation.min_length', { num: field.$params.minLenghtOptional.min })
          }
          if (field.$params.singlePhone && !field.singlePhone) {
            return this.$t('validation.invalid_single_phone')
          }
          if (field.$params.internationalCode && !field.internationalCode) {
            return this.$t('validation.select_international_code')
          }

          if (!field.required) {
            return this.$t('validation.required')
          }
        }
      }
    }
  }
}

export default formHelperMixin
